/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React, { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";

export default function LoginUI({
  COLORS,
  isArabic,
  isMobile,
  form,
  loading,
  handleChange,
  handleSubmit,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const FIELD_BG = "#6E3B8E";
  const FIELD_BORDER = "#9B6BC2";
  const TEXT_COLOR = "#E0E0E0"; // Softer gray instead of pure white

  return (
    <div
      style={{
        background: "#112758",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "30px",
        fontFamily: "'Tajawal', 'Cairo', sans-serif",
        color: COLORS.textLight,
      }}
    >
      <div
        style={{
          maxWidth: isMobile ? "100%" : 450,
          width: "100%",
          background: "rgba(255,255,255,0.08)",
          border: "1px solid rgba(255,255,255,0.15)",
          borderRadius: isMobile ? 14 : 18,
          padding: isMobile ? "25px 15px" : "40px 30px",
          boxShadow: "0 8px 25px rgba(0,0,0,0.3)",
          backdropFilter: "blur(12px)",
          direction: isArabic ? "rtl" : "ltr",
          color: "#fff",
          margin: isMobile ? "10px" : "0",
        }}
        className="animate__animated animate__fadeInUp"
      >
        <h3
          className="fw-bold text-center mb-3"
          style={{
            color: COLORS.gold,
            fontFamily: "'Cairo', sans-serif",
            fontSize: isMobile ? "1.5rem" : "1.8rem",
          }}
        >
          {isArabic ? "تسجيل الدخول" : "Sign In"}
        </h3>

        <p
          className="text-center mb-4"
          style={{
            color: COLORS.textLight,
            opacity: 0.85,
            fontSize: isMobile ? "0.9rem" : "1rem",
            padding: isMobile ? "0 10px" : "0",
          }}
        >
          {isArabic
            ? "أدخل بريدك الإلكتروني وكلمة المرور للوصول إلى حسابك."
            : "Enter your email and password to access your account."}
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold text-white">
              {isArabic ? "البريد الإلكتروني" : "Email"}
            </label>
            <input
              type="email"
              name="email"
              autoComplete="username"
              className="form-control"
              value={form.email}
              onChange={handleChange}
              style={{
                background: FIELD_BG,
                color: TEXT_COLOR,
                borderRadius: 10,
                border: `1px solid ${FIELD_BORDER}`,
                boxShadow: "inset 0 2px 4px rgba(0,0,0,0.2)",
                fontSize: isMobile ? "0.9rem" : "1rem",
                padding: isMobile ? "8px 12px" : "10px 15px",
              }}
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold text-white">
              {isArabic ? "كلمة المرور" : "Password"}
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                autoComplete="current-password"
                className="form-control"
                value={form.password}
                onChange={handleChange}
                style={{
                  background: FIELD_BG,
                  color: TEXT_COLOR,
                  borderRadius: 10,
                  border: `1px solid ${FIELD_BORDER}`,
                  boxShadow: "inset 0 2px 4px rgba(0,0,0,0.2)",
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  padding: isMobile ? "8px 12px" : "10px 15px",
                }}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  top: "50%",
                  transform: "translateY(-50%)",
                  [isArabic ? "left" : "right"]: "15px",
                  cursor: "pointer",
                  color: COLORS.gold, // or "#ccc"
                  fontSize: "1.2rem",
                }}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </span>
            </div>
            <div className="text-end mt-2">
              <a
                href="/reset-password"
                className="fw-semibold"
                style={{
                  fontSize: isMobile ? "0.8rem" : "0.9rem",
                  color: COLORS.gold,
                  textDecoration: "none",
                }}
              >
                {isArabic ? "نسيت كلمة المرور؟" : "Forgot password?"}
              </a>
            </div>
          </div>

          <button
            type="submit"
            className="btn w-100 fw-semibold py-2 mt-3"
            style={{
              background: COLORS.gold,
              color: COLORS.darkPurple,
              borderRadius: 10,
              boxShadow: "0 4px 15px rgba(242,180,65,0.4)",
              transition: "0.3s",
              fontSize: isMobile ? "0.95rem" : "1rem",
              padding: isMobile ? "10px" : "12px",
            }}
            disabled={loading}
          >
            {loading
              ? isArabic
                ? "جارٍ تسجيل الدخول..."
                : "Signing in..."
              : isArabic
                ? "تسجيل الدخول"
                : "Sign In"}
          </button>

          <p
            className="text-center mt-4"
            style={{
              color: COLORS.textLight,
              fontSize: isMobile ? "0.85rem" : "0.95rem",
            }}
          >
            {isArabic ? "ليس لديك حساب؟ " : "Don't have an account? "}
            <a
              href="/signup"
              className="fw-semibold"
              style={{
                color: COLORS.gold,
                fontSize: isMobile ? "0.85rem" : "0.95rem",
              }}
            >
              {isArabic ? "إنشاء حساب" : "Create one"}
            </a>
          </p>
        </form>
      </div>
    </div>
  );
}

